import { RouterProvider } from "react-router-dom";
import router from "./Router";

export default function Routers() {
  return <RouterProvider router={router} />;
}
